module.exports = __webpack_public_path__ + "img/pinpaiwangzhan.6b751beb.png";